import React, { useState, useEffect } from 'react';
import { useAuth, API_URL, Currency } from '../contexts/AuthContext';
import { Plus, Users, Search } from 'lucide-react';

export default function Fornecedores() {
  const { token } = useAuth();
  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: '', contact_name: '', phone: '', email: '', address: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/suppliers`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setSuppliers(d)).catch(() => {});
  }, [token]);

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/suppliers/`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify(form) });
      if (!r.ok) { setMsg('Erro ao salvar'); return; }
      setMsg('Fornecedor salvo'), setOpen(false);
      fetch(`${API_URL}/suppliers`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setSuppliers(d)).catch(() => {});
    } catch { setMsg('Erro interno'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Fornecedores</h1>
          <p className="text-gray-600">Cadastro de fornecedores de bebidas</p>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary"><Plus size={18} /> Novo fornecedor</button>
      </div>
      {msg && <div className="rounded-lg p-3 text-sm bg-green-50 border border-green-200 text-green-700">{msg}</div>}
      <div className="table-wrap">
        <table className="w-full text-left text-sm">
          <thead><tr className="border-b border-gray-200"><th className="pb-2 text-gray-500">Nome</th><th className="pb-2 text-gray-500">Contato</th><th className="pb-2 text-gray-500">Telefone</th><th className="pb-2 text-gray-500">E-mail</th></tr></thead>
          <tbody>
            {suppliers.map(s => (
              <tr key={s.id} className="border-b border-gray-100 last:border-0">
                <td className="py-2 font-medium">{s.name}</td>
                <td className="py-2">{s.contact_name || '-'}</td>
                <td className="py-2">{s.phone || '-'}</td>
                <td className="py-2">{s.email || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Novo fornecedor</h2>
            <form onSubmit={save} className="space-y-3">
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Nome</label><input className="input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Nome do contato</label><input className="input" value={form.contact_name} onChange={e => setForm({ ...form, contact_name: e.target.value })} /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Telefone</label><input className="input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">E-mail</label><input className="input" type="email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Endereço</label><input className="input" value={form.address} onChange={e => setForm({ ...form, address: e.target.value })} /></div>
              <div className="flex justify-end gap-2 pt-4">
                <button type="button" onClick={() => setOpen(false)} className="btn-ghost px-4">Cancelar</button>
                <button className="btn-primary">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
